export default __webpack_public_path__ + "static/media/start_EN.3783987f.png";